import { render, staticRenderFns } from "./crudReportSeller.vue?vue&type=template&id=2a1a1178&scoped=true&"
import script from "./crudReportSeller.vue?vue&type=script&lang=js&"
export * from "./crudReportSeller.vue?vue&type=script&lang=js&"
import style0 from "./crudReportSeller.vue?vue&type=style&index=0&id=2a1a1178&prod&lang=css&"
import style1 from "./crudReportSeller.vue?vue&type=style&index=1&id=2a1a1178&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a1178",
  null
  
)

export default component.exports